import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HttpErrorResponse } from '@angular/common/http';
import { Log } from '@gspwidget/util';

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {

  notiTmpl

  constructor (
    private noti: NzNotificationService
  ) {
    this.noti.config({
      nzPlacement: 'topRight',
      // nzDuration: 0,
      nzTop: 14,
    })
  }

  /** 必需这么着存一个 tmpl 才能用。实在是没想到有什么更好的办法 */
  init (notiTmpl) {
    this.notiTmpl = notiTmpl
  }

  notify (errRes: HttpErrorResponse) {
    if (typeof errRes.error === 'string') {
      try {
        errRes['errorObj'] = JSON.parse(errRes.error)
      } catch (e) {
        Log.Error(errRes.error)
      }
    } else {
      errRes['errorObj'] = errRes.error
    }
    this.noti.template(this.notiTmpl, { nzData: errRes })
  }
}
